export default {
  init() {
    // JavaScript to be fired on all pages
    let header = document.getElementById('site-header');
    if(header.classList.contains('fixed')) {
      document.querySelector('main').classList.add('pt-16');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js